import type { StateCreator } from 'zustand';

import type { UserSlice } from './types';

export type { UserSlice } from './types';

export const userInitialState = {
  areCreditsAvailable: null as boolean | null,
  availableCredits: null as number | null,
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  ...userInitialState,

  setAreCreditsAvailable: (areCreditsAvailable) => set({ areCreditsAvailable }),
});
